import * as vp from 'vopay';
import { FunctionComponent, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { DialogueHandler, ConfirmTransactionDialogueHandler } from '../../Dialogue/types';
import CopyButton from '@/components/UI/CopyButton/CopyButton';
import styles from './ConfirmTransactionDialogue.module.scss';

const { ConfirmationDialogue, Box, MaterialSymbol } = vp;

type ConfirmTransactionDialogueProps = {
  handleDialogue: DialogueHandler<ConfirmTransactionDialogueHandler>;
  showConfirmTransactionErrorAlert: boolean;
  sendConfirmTransactionError: string;
  showConfirmTransaction: boolean;
  flaggedMessage: string;
};

type FC = FunctionComponent<ConfirmTransactionDialogueProps>;

const ConfirmTransactionDialogue: FC = ({
  handleDialogue,
  showConfirmTransactionErrorAlert,
  sendConfirmTransactionError,
  showConfirmTransaction,
  flaggedMessage,
}: ConfirmTransactionDialogueProps) => {
  const { t } = useTranslation('translations', {
    keyPrefix: 'Transaction.Dialogue.ConfirmTransaction.ConfirmTransactionDialogue',
  });

  return useMemo(
    () => (
      <div>
        {/* Flagged Transaction Confirm Error */}
        <ConfirmationDialogue
          isVisible={showConfirmTransactionErrorAlert}
          title={t('errorDialogue.title')}
          status="error"
          subTitle={`${sendConfirmTransactionError}`}
          confirm={{
            label: t('errorDialogue.back'),
            action: () => handleDialogue({ type: 'error', state: 'fail' }),
          }}
        />
        {/* Flagged Transaction Confirm */}
        <ConfirmationDialogue
          isVisible={showConfirmTransaction}
          width="min(90vw, 529px)"
          title={
            <Box flx="col" gapSize="24px">
              <div>
                <MaterialSymbol icon="flag" color="#BD3A2D" size="104px" fillAmount={1} className={styles.flag} />
              </div>
              {t('confirmDialogue.title')}
            </Box>
          }
          status="none"
          subTitle={
            <Box gapSize="16px" jc="center" ai="center">
              {flaggedMessage}
              <CopyButton content={flaggedMessage} />
            </Box>
          }
          confirm={{
            label: t('confirmDialogue.removeFlag'),
            action: () => handleDialogue({ type: 'confirm', state: 'success' }),
          }}
          cancel={{
            label: t('confirmDialogue.close'),
            action: () => handleDialogue({ type: 'confirm', state: 'fail' }),
          }}
        />
      </div>
    ),
    [showConfirmTransactionErrorAlert, sendConfirmTransactionError, flaggedMessage, showConfirmTransaction],
  );
};

export default ConfirmTransactionDialogue;
